<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3333 4.04173V13.9501C18.3333 14.7584 17.675 15.5001 16.8667 15.6001L16.6083 15.6334C15.2417 15.8167 13.3167 16.3834 11.7667 17.0334C11.225 17.2584 10.625 16.8501 10.625 16.2584V4.66673C10.625 4.3584 10.8 4.07507 11.075 3.92507C12.6 3.10007 14.9083 2.36673 16.475 2.2334H16.525C17.525 2.2334 18.3333 3.04173 18.3333 4.04173Z"
      fill="#292D32"
    />
    <path
      d="M8.92499 3.92507C7.39999 3.10007 5.09166 2.36673 3.52499 2.2334H3.46666C2.46666 2.2334 1.65833 3.04173 1.65833 4.04173V13.9501C1.65833 14.7584 2.31666 15.5001 3.12499 15.6001L3.38333 15.6334C4.74999 15.8167 6.67499 16.3834 8.22499 17.0334C8.76666 17.2584 9.36666 16.8501 9.36666 16.2584V4.66673C9.36666 4.35006 9.19999 4.07507 8.92499 3.92507ZM4.16666 6.45006H6.04166C6.38333 6.45006 6.66666 6.7334 6.66666 7.07506C6.66666 7.42506 6.38333 7.70006 6.04166 7.70006H4.16666C3.82499 7.70006 3.54166 7.42506 3.54166 7.07506C3.54166 6.7334 3.82499 6.45006 4.16666 6.45006ZM6.66666 10.2001H4.16666C3.82499 10.2001 3.54166 9.92506 3.54166 9.57506C3.54166 9.2334 3.82499 8.95006 4.16666 8.95006H6.66666C7.00833 8.95006 7.29166 9.2334 7.29166 9.57506C7.29166 9.92506 7.00833 10.2001 6.66666 10.2001Z"
      fill="#292D32"
    />
  </svg>
</template>


<script>
export default {
  name: "LearningGoalsIcon",

  data() {
    return {};
  },
  computed: {},
};
</script>